import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const roleApi = createApi({
    reducerPath: "roleApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["Roles"],
    endpoints: (builder) => ({
        // Get Resourcees
        getResources: builder.query({
            query: () => "/roles/resources",
            transformResponse: (response) => response.data || response,
            providesTags: ["Roles"],
        }),
        // Get all Roles. The list endpoint defaults to a page size of 20
        // (server max 100), which silently drops roles past that once the
        // list grows - every consumer of this hook expects the full list
        // (dropdowns, the Roles admin table), so request the max explicitly.
        getRoles: builder.query({
            query: () => "/roles?limit=100",
            transformResponse: (response) => response.data || response,
            providesTags: ["Roles"],
        }),

        // Get a single Role
        getRoleById: builder.query({
            query: (id) => `/roles/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: "Roles", id }],
        }),

        // Create a new Role
        createRole: builder.mutation({
            query: (wasteStream) => ({
                url: `/roles`,
                method: "POST",
                body: wasteStream,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["Roles"],
        }),

        // Update an existing Role
        updateRole: builder.mutation({
            query: ({ id, ...wasteStream }) => ({
                url: `/roles/${id}`,
                method: "PUT",
                body: wasteStream,
            }),
            invalidatesTags: ["Roles"],
        }),

        // Delete an existing Role
        deleteRole: builder.mutation({
            query: (id) => ({
                url: `/roles/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Roles"],
        }),
    }),
});

export const {
    useGetResourcesQuery,
    useGetRolesQuery,
    useGetRoleByIdQuery,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useDeleteRoleMutation,
} = roleApi;